import React from "react";
import numeral from "numeral";
import { getRange, getPrettyNumber } from "aible";

import { AutoSizer } from "react-virtualized";
import { LineChart, ResponsiveContainer, ReferenceLine, Line, XAxis, YAxis, Tooltip } from "recharts";

import styles from "./style.module.css";
import { GRAPH_MODES, TARGET_VALUE_MODES } from "containers/Monitoring/reducer";

const CustomToolTip = (props) => {
  const { active, payload, assumedKey, actualKey } = props;
  if (!active || !payload) {
    return null;
  }

  const date = payload[0] && payload[0].payload && payload[0].payload.date;

  payload.sort((a, b) => (b.name > a.name ? 1 : -1));
  return (
    <div className={styles.toolTipWrapper}>
      <div className={styles.toolTopBody}>
        <strong>{"Date: "}</strong>
        {date}
      </div>
      <div style={{ padding: "4px" }} />
      {payload.map((data, i) => {
        if (!data.payload || data.value === undefined) {
          return <div key={"maingraph" + i} />;
        }
        let name = data.payload[data.dataKey.charAt(0) + "Name"];
        if (data.dataKey === actualKey) {
          name = "Actual";
        } else if (data.dataKey === assumedKey) {
          name = "Projected";
        }
        return (
          <div key={"maingraph" + i} className={styles.toolTopBody} style={{ color: data.color }}>
            <strong>{name + ": "}</strong>
            {numeral(data.value).format("0,0" + (data.value > 1000 ? "" : ".[00]"))}
          </div>
        );
      })}
    </div>
  );
};

const HIDE_ASSUMED_LINE = [
  TARGET_VALUE_MODES.AVERAGE_DEVIATION,
  TARGET_VALUE_MODES.TOTAL_SUM,
  TARGET_VALUE_MODES.AVERAGE_SUM
];

const CountsGraph = (props) => {
  const { data, segmentId, graphMode, targetValue } = props;
  if (!data) return null;

  let graphData = segmentId && data[segmentId].data;

  const assumedKey = graphMode === "Daily" ? "countAssumed" : "cumulativeAssumedCount";
  const actualKey = graphMode === "Daily" ? "count" : "cumulativeCount";

  const yDataMin = Math.min.apply(
    Math,
    graphData.flatMap((p) => [p[assumedKey], p[actualKey]])
  );
  const yDataMax = Math.max.apply(
    Math,
    graphData.flatMap((p) => [p[assumedKey], p[actualKey]])
  );
  const yDomain = yDataMin === yDataMax ? undefined : getRange(yDataMin, yDataMax, true);

  const showAssumed = !HIDE_ASSUMED_LINE.includes(targetValue);

  return (
    <div id={"countsGraph"} className={styles.countsGraph}>
      <AutoSizer>
        {({ width, height }) => (
          <LineChart width={width} height={height} data={graphData} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
            <Tooltip
              content={<CustomToolTip />}
              itemStyle={{ fontSize: "14px" }}
              contentStyle={{ fontSize: "14px" }}
              wrapperStyle={{ background: "#FFFFFF" }}
              assumedKey={assumedKey}
              actualKey={actualKey}
            />
            <XAxis dataKey={"date"} />
            {showAssumed && <Line dataKey={assumedKey} stroke={"#F47C20"} strokeWidth={3} dot={false} />}
            <Line dataKey={actualKey} stroke={"#512F77"} strokeWidth={3} dot={false} />
            <ReferenceLine y={0} strokeDasharray="3 3" />
            <YAxis domain={yDomain} tickFormatter={(tick) => getPrettyNumber(tick)} />
          </LineChart>
        )}
      </AutoSizer>
    </div>
  );
};

export default CountsGraph;
